const initialState = {
	accounts: 0
};

const AccountValidationReducer = (state = initialState, action = {}) => {
	switch (action.type) {
		case 'CHECK_ACCOUNTS':
			return {
				...state,
				accounts: action.payload
			};
		default:
			return state;
	}
};

export default AccountValidationReducer;